import { Schema as S } from "effect";

export const GetPatientFromTerminalRequestSchema = S.Struct({
  terminalId: S.String,
});

export type GetPatientFromTerminalRequest = S.Schema.Type<typeof GetPatientFromTerminalRequestSchema>;
